import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import ChargeTemplateFactory from "../../Entity/Factories/ChargeTemplateFactory";

export default function* chargeTemplateList(action: ActionInterface): any {
  try {

    const res = yield call(Http.get, "charge-templates");

    const chargeTemplates = res.data.map(chargeTemplate => {
      return ChargeTemplateFactory.create(chargeTemplate);
    });

    yield put({
      type: Constants.GLOBAL_CHARGE_TEMPLATE_LIST_SUCCESS,
      payload: {
        chargeTemplates: chargeTemplates
      }
    });

  } catch (err) {
    // should signout user if entity could not be loaded
    yield put({
      type: Constants.PAGE_SIGNOUT_START
    });
    
    yield ErrorHandlerSequence(err, action);
  }
}

export function* watchChargeTemplateList() {
  yield takeEvery(Constants.GLOBAL_CHARGE_TEMPLATE_LIST, chargeTemplateList);
}
